import { lazy, Suspense } from 'react';
import { Loader } from '@/shared/ui';

const DashboardBuilder = lazy(() =>
  import('./DashboardBuilder').then(({ DashboardBuilder }) => ({
    default: DashboardBuilder,
  })),
);

export function DashboardBuilderLazy() {
  return (
    <Suspense fallback={<Loader active />}>
      <DashboardBuilder />
    </Suspense>
  );
}
